import { useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const useDeviceFingerprint = () => {
  const [fingerprint, setFingerprint] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const getFingerprint = async (): Promise<string> => {
    if (fingerprint) {
      return fingerprint;
    }

    setLoading(true);
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const visitorId = result.visitorId;
      setFingerprint(visitorId);
      return visitorId;
    } catch (error) {
      console.error('Error generating fingerprint:', error);
      // Fallback to a random ID if fingerprinting fails
      const fallbackId = `fallback_${Date.now()}_${Math.random()}`;
      setFingerprint(fallbackId);
      return fallbackId;
    } finally {
      setLoading(false);
    }
  };

  return { 
    fingerprint, 
    loading, 
    getFingerprint 
  };
};
